var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "hidden-sm-only"
  }, [_c('v-tabs', {
    attrs: {
      "background-color": "transparent",
      "grow": "",
      "mobile-breakpoint": "9999"
    },
    model: {
      value: _vm.c.current,
      callback: function callback($$v) {
        _vm.$set(_vm.c, "current", $$v);
      },
      expression: "c.current"
    }
  }, _vm._l(3, function (i) {
    return _c('v-tab', {
      key: "collection-tab-".concat(i),
      staticClass: "px-0"
    }, [_vm._v(_vm._s(i))]);
  }), 1)], 1), _c('div', {
    staticClass: "hidden-xs-only hidden-md-and-up"
  }, [_c('v-list-item', {
    on: {
      "click": function click($event) {
        _vm.c.current = (_vm.c.current + 1) % 3;
      }
    }
  }, [_c('v-list-item-content', [_c('div', {
    staticClass: "text-center primary--text",
    staticStyle: {
      "font-size": "14px",
      "font-weight": "500"
    }
  }, [_vm._v(_vm._s(_vm.c.current + 1))])])], 1)], 1), _c('v-divider'), _c('v-tabs-items', {
    model: {
      value: _vm.c.current,
      callback: function callback($$v) {
        _vm.$set(_vm.c, "current", $$v);
      },
      expression: "c.current"
    }
  }, _vm._l(3, function (i) {
    return _c('v-tab-item', {
      key: "collection-tab-item-".concat(i)
    }, [_c('v-list', {
      staticClass: "overflow-y-auto py-0",
      staticStyle: {
        "height": "calc(100vh - 56px - 48px - 2px - 52px)"
      }
    }, [_vm._l(_vm.c.collections[i - 1].slice().reverse(), function (collection, j) {
      return [j ? _c('v-divider') : _vm._e(), collection.name == 'Character' ? _c('Character', {
        key: "collection-".concat(i, "-").concat(collection.name, "-").concat(collection.id),
        attrs: {
          "id": collection.id,
          "collection": ""
        }
      }) : collection.name == 'Weapon' ? _c('Weapon', {
        key: "collection-".concat(i, "-").concat(collection.name, "-").concat(collection.id),
        attrs: {
          "id": collection.id,
          "collection": ""
        }
      }) : collection.name == 'Quest Library' ? _c('QuestLibrary', {
        key: "collection-".concat(i, "-").concat(collection.name, "-").concat(collection.id),
        attrs: {
          "id": collection.id,
          "collection": ""
        }
      }) : collection.name == 'Enemy' ? _c('Enemy', {
        key: "collection-".concat(i, "-").concat(collection.name, "-").concat(collection.id),
        attrs: {
          "level": parseInt(collection.level),
          "qid": collection.qid,
          "id": collection.id,
          "collection": ""
        }
      }) : collection.name == 'Item' ? _c('Item', {
        key: "collection-".concat(i, "-").concat(collection.name, "-").concat(collection.id),
        attrs: {
          "id": collection.id,
          "collection": ""
        }
      }) : collection.name == 'Room Object' ? _c('RoomObject', {
        key: "collection-".concat(i, "-").concat(collection.name, "-").concat(collection.id),
        attrs: {
          "id": collection.id,
          "collection": ""
        }
      }) : collection.name == 'Town Object' ? _c('TownObject', {
        key: "collection-".concat(i, "-").concat(collection.name, "-").concat(collection.id),
        attrs: {
          "id": collection.id,
          "collection": ""
        }
      }) : collection.name == 'Master Orb' ? _c('Orb', {
        key: "collection-".concat(i, "-").concat(collection.name, "-").concat(collection.id),
        attrs: {
          "id": collection.id,
          "collection": ""
        }
      }) : _c('v-list-item', {
        key: "collection-".concat(i, "-").concat(collection.name, "-").concat(collection.id),
        attrs: {
          "to": {
            name: collection.name,
            params: {
              id: collection.id
            }
          }
        }
      }, [_c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t(collection.name)))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(collection.id))])], 1)], 1)];
    })], 2), _c('v-divider'), _c('v-list-item', [_c('v-list-item-icon', {
      staticClass: "ma-2 ml-0"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("mdi-filter")])], 1)], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.c.collections[i - 1].length) + " " + _vm._s(_vm.$t('Pages')))])], 1), _c('v-list-item-action', {
      staticClass: "ma-2 mr-0"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function click($event) {
          _vm.c.collections[i - 1].splice(0);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)], 1)], 1)], 1);
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }